import { Avatar, Button, Stack } from '@mui/material';
import { MAX_SHIELD_BYTES } from './tournamentSetupHelpers';

export default function TournamentSetupShieldPicker({ value, onChange, disabled, onFileTooLarge }) {
  return (
    <Stack direction="row" alignItems="center" gap={1.5} flexWrap="wrap">
      <Avatar
        src={value || undefined}
        alt=""
        variant="rounded"
        sx={{
          width: 52,
          height: 52,
          border: '1px solid',
          borderColor: 'divider',
          bgcolor: 'grey.100',
        }}
      />
      <Stack direction="row" gap={0.5} alignItems="center" flexWrap="wrap">
        <Button variant="outlined" component="label" size="small" disabled={disabled} sx={{ textTransform: 'none' }}>
          Subir escudo
          <input
            type="file"
            hidden
            accept="image/jpeg,image/png,image/webp,image/gif"
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (!file) return;
              if (file.size > MAX_SHIELD_BYTES) {
                onFileTooLarge?.();
                e.target.value = '';
                return;
              }
              const reader = new FileReader();
              reader.onloadend = () => {
                onChange(typeof reader.result === 'string' ? reader.result : '');
              };
              reader.readAsDataURL(file);
              e.target.value = '';
            }}
          />
        </Button>
        {value ? (
          <Button
            type="button"
            size="small"
            disabled={disabled}
            onClick={() => onChange('')}
            sx={{ textTransform: 'none' }}
          >
            Quitar imagen
          </Button>
        ) : null}
      </Stack>
    </Stack>
  );
}
